import { EFinancingProgram } from '@if/core/types'
import { Container } from '@mui/material'
import { useUserSupportsProgram } from '../ViewCreditApplicationPage/credit-hooks'
import ProductsCalculator from './components/ProductsCalculator'
import PersonalLoanCalculator from './components/PersonalLoanCalculator'

const CalculatorPage = () => {
  const supportsProducts = useUserSupportsProgram(EFinancingProgram.Products)
  const supportsPersonal = useUserSupportsProgram(EFinancingProgram.Personal)
  return (
    <Container maxWidth={supportsProducts ? 'sm' : 'lg'}>
      {supportsProducts && <ProductsCalculator />}
      {supportsPersonal && <PersonalLoanCalculator />}
    </Container>
  )
}

export default CalculatorPage
